import { Box, Typography } from "@mui/material";
import { ButtonCust, SearchBoxWithDropdown } from "../../../widgets";
import CountryDataModal from "./CountryDataModal";
import _ from "lodash";
import { getResolutionDetails } from "../../../../utils/commonFunctions";
import Config from "../../../../config/env.config.json";
import { RoutingURLs } from "../../../../config/RoutingURLs";
import { gtmTagManager } from "../../../../utils/commonFunctions/GtmTagManager";
import { useAppSelector } from "../../../../app/hooks";

const ViewRates = (props: any) => {
  const { view_Rates, back_icon, back_txt, desc, callAnywhere } = props.content;
  const { globalVal } = useAppSelector(
    (state: any) => state?.strapi?.globalValues || {}
  );
  const {
    isCountryModal,
    countryModalHandler,
    selectedCountry,
    getCountryList,
    setSelectedCountryHandler,
    renderOption,
    setSelectedCountry,
  } = props;
  const { mobile } = getResolutionDetails();
  const onTextChange = (e: any) => {
    if (e.target.value === "") {
      setSelectedCountry(undefined);
    }
  };
  return (
    <>
      <CountryDataModal
        isCountryModal={isCountryModal}
        setIsCountryModal={countryModalHandler}
        selectedCountry={selectedCountry}
        view_Rates={view_Rates}
      />
      <Box
        sx={{
          position: "relative",
          width: "100%",
          textAlign: "center",
          top: "-50px",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& span": {
              fontWeight: "var(--font_weight_5)",
            },
          }}
        >
          <Box
            component="span"
            sx={{
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
              position: "absolute",
              left: { xs: "20px", md: "103px" },
              cursor: "pointer",
              fontWeight: "var(--font_weight_3)",
            }}
            onClick={() => props.setIsViewRates(false)}
          >
            <Box
              component="img"
              src={back_icon?.data.attributes.url}
              alt={back_icon?.data.attributes.alternativeText}
            />
            {!mobile && (
              <Box
                component="span"
                sx={{
                  textDecoration: "underline",
                }}
              >
                {back_txt}
              </Box>
            )}
          </Box>
          <Box
            component="span"
            style={{ margin: "auto" }}
            sx={{
              fontFamily: "var(--font_family_Bold) !important",
              fontSize: { xs: "24px", md: "40px" },
            }}
          >
            {view_Rates.subheading}
          </Box>
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "18px" },
              fontFamily: "var(--font_family_Bold)",
              fontWeight: "var(--font_weight_4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginY: "30px",
              color: "var(--text_color)",
            }}
          >
            {callAnywhere}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "inline-block",
            width: { xs: "90%", md: "500px !important" },
            mt: "40px",
          }}
        >
          <Box
            sx={{
              fontSize: "14px",
              // fontWeight: "var(--font_weight_0)",
              fontFamily: "var(--font_family_Medium)",
              textAlign: "left",
              pb: "5px",
            }}
          >
            {view_Rates.premium_qual}
          </Box>
          <SearchBoxWithDropdown
            dropdownList={getCountryList}
            optionLabel={(option: any) =>
              option.name ? option.name : option.countryName
            }
            value={selectedCountry}
            onChange={setSelectedCountryHandler}
            placeholder={view_Rates.search_placeholder}
            onRequest={() => null}
            onCancel={() => setSelectedCountry("")}
            logo={view_Rates.search_icon}
            renderOption={renderOption}
            no_option={view_Rates.no_option}
            onTextChange={onTextChange}
            sx={{
              "& .MuiFilledInput-input": {
                fontFamily: "var(--font_family_Medium) !important",
                color: "var(--text-color) !important",
              },
            }}
          />
          {selectedCountry && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontFamily: "var(--font_family_Semibold)",
                  mt: "30px",
                }}
              >
                {desc}
              </Typography>
              <Typography
                sx={{
                  fontSize: "18px",
                  fontFamily: "var(--font_family_Semibold)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {view_Rates.call_US}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              fontFamily: "var(--font_family_Medium)",
              flexDirection: "column",
              marginTop: "30px",
            }}
          >
            <Box>
              <ButtonCust
                variantType={Config.SECONDARY_BUTTON_TYPE}
                onClick={() => {
                  window.open(globalVal?.helpCenter, "_blank");
                  gtmTagManager({
                    event: globalVal?.gtmEvents?.ILDFAQ,
                    click_section: "International Calling",
                  });
                }}
                sx={{
                  color: "var(--text_color) !important",
                  padding: "0 20px",
                  "&:hover": {
                    border: "1px solid var(--red-color_5) !important",
                  },
                }}
              >
                {view_Rates?.ask_question}
              </ButtonCust>
            </Box>
            <Typography
              sx={{
                color: "var(--text_color)",
                cursor: "pointer",
                fontFamily: "var(--font_family_Bold)",
                textDecoration: "underline",
                fontWeight: "var(--font_weight_4)",
                mt: "30px",
              }}
              onClick={() => {
                window.open("", "_blank");
                gtmTagManager({
                  event: globalVal?.gtmEvents?.IRTermsAndConditions,
                  click_section: "International Calling",
                });
              }}
            >
              {view_Rates?.terms_text}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ViewRates;
